import { DateTimeField } from '@mi-front/ui';
import moment from 'moment-timezone';
import { useIntl } from 'react-intl';
import { useTimezone } from '../../../../../../core/hooks';

export function MissingAudioReportForm(p: any) {
  const { $t } = useIntl();
  const tz = useTimezone();

  return (
    <div className="row">
      <div className="col-4">
        <DateTimeField
          name="from"
          dateLabel={$t({
            id: 'common.dateStart',
            defaultMessage: 'Fecha inicio',
          })}
          timeLabel={$t({
            id: 'common.timeStart',
            defaultMessage: 'Hora inicio',
          })}
          isOutsideRange={(date) => moment(date) > moment()}
          tz={tz}
        />
      </div>
      <div className="col-4">
        <DateTimeField
          name="to"
          dateLabel={$t({
            id: 'common.dateEnd',
            defaultMessage: 'Fecha fin',
          })}
          timeLabel={$t({
            id: 'common.timeEnd',
            defaultMessage: 'Hora fin',
          })}
          isOutsideRange={(date) => moment(date) > moment()}
          tz={tz}
        />
      </div>
    </div>
  );
}
